<template>
  <transition name="search-expand">
    <div class="search__inner-full" v-if="expanded">
      <form class="search__advanced-form" ref="form" :action="page">
        <label class="search__search-form-label">
          <span>With all of the words: </span>
          <input type="text" name="as_q" :value="allWords" />
        </label>

        <label class="search__search-form-label">
          <span>With the exact phrase: </span>
          <input type="text" name="as_epq" :value="exactWords" />
        </label>

        <label class="search__search-form-label">
          <span>With at least one of the words: </span>
          <input type="text" name="as_oq" :value="oneWord" />
        </label>

        <label class="search__search-form-label">
          <span>Without the words:</span>
          <input type="text" name="as_eq" :value="withoutWords" />
        </label>

        <div class="search__advanced-form-submit">
          <button
            type="submit"
            class="base-btn-primary base-btn-primary--dark btn"
          >
            Search
          </button>
        </div>
      </form>
    </div>
  </transition>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  props: {
    page: {
      type: String,
      default: '/search-results',
    },
  },
  data() {
    return {
      expanded: false,
      params: Object,
    }
  },
  methods: {
    toggleExpanded(expanded) {
      this.expanded = expanded
    },
  },
  computed: {
    allWords: function() {
      if (this.params.get('as_q')) {
        return this.params.get('as_q')
      } else {
        return this.params.get('q')
      }
    },
    exactWords: function() {
      return this.params.get('as_epq')
    },
    oneWord: function() {
      return this.params.get('as_oq')
    },
    withoutWords: function() {
      return this.params.get('as_eq')
    },
  },
  mounted() {
    eventBus.$on('search:advanced', this.toggleExpanded)

    this.params = new URLSearchParams(window.location.search.substring(1))
  },
}
</script>

<style lang="scss" scoped>
.search-expand-enter-active,
.search-expand-leave-active {
  transition: all 0.25s ease-in;
}

.search-expand-enter,
.search-expand-leave-to {
  transform: translateY(-25px);
  opacity: 0;
}
</style>
